<template>
	<div class="itemMatome sort-item"
		v-if="!(ptInitData.productInfo.FORM_LP_FLG == 1 && isLp) && ptInitData.productInfo && !common.isNullItem(ptInitData.productInfo.LINK_NM) && ((ptInitData.loginKbn && ptInitData.productInfo.NEED_MEMBER_FLG == 1) || ptInitData.productInfo.NEED_MEMBER_FLG == 0)">
		<button class="btnSuccess" @click="showMatomeDetail(ptInitData.productInfo)">
			<!-- まとめ買い割引情報-->
			<span v-html="ptInitData.productInfo.LINK_NM"></span>
		</button>
	</div>
</template>
<script>
import common from "assets/js/common";
	export default{
		name: 'itemMatome',
		props: {
			ptInitData: {
				type: Object,
				default: null
			},
			isLp: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			showMatomeDetail(productInfo) {
				this.$emit('showMatomeDetail', productInfo);
			}
		},
		data: function() {
			return {
				common
			}
		},
	}
</script>